import React, { useCallback, useContext, useEffect, useState } from "react";
import EstimateModal from "../../../components/modal/estimateModal/EstimateModal";
import { api } from "../../../config/api";
import { util } from "../../../config/util";
import AlertContext from "../../../contexts/AlertContext";
import { EstimateService } from "../../../models/EstimateService";
import styles from "../mainRedesign.module.scss";

export default () => {
  const [estimateData, setEstimateData] = useState<EstimateService[]>([]);
  const [isOpenModal, setOpenModal] = useState<boolean>(false);
  const statusMapper: { [key in string]: string } = {
    request: "상담중",
    progress: "진행중",
    completed: "납품완료",
  };
  const statusClassMapper: { [key in string]: string } = {
    request: styles.statusRequest,
    progress: styles.statusProgress,
    completed: styles.statusCompleted,
  };
  const alert = useContext(AlertContext);
  const onClickToggleModal = useCallback(() => {
    setOpenModal(!isOpenModal);
  }, [isOpenModal]);

  useEffect(() => {
    api
      .getEstimate()
      .then((result) => {
        const response: EstimateService[] = result.data.estimate_services;
        response.sort((a, b) => {
          if (a.status === b.status) {
            return a.start_date > b.start_date ? -1 : 1;
          } else {
            return a.status > b.status ? -1 : 1;
          }
        });
        setEstimateData(response);
      })
      .catch((error) => {
        console.error("에러발생 : ", error);
      });
  }, []);

  // 마키 효과를 위해 데이터를 2배로 복제
  const marqueeItems = estimateData.length > 0
    ? [...estimateData, ...estimateData]
    : [];

  return (
    <section className={styles.requestSection}>
      {/* 상단: 제목 + 통계 + CTA 한 줄 */}
      <div className={styles.requestTop}>
        <h2 className={styles.requestTitle}>
          콘엑스 용역서비스
        </h2>
        <div className={styles.requestStats}>
          <div className={styles.statItem}>
            <div className={styles.statNumber}>2,140+</div>
            <div className={styles.statLabel}>의뢰 건수</div>
          </div>
          <div className={styles.statItem}>
            <div className={styles.statNumber}>523억+</div>
            <div className={styles.statLabel}>총 공사비</div>
          </div>
          <div className={styles.statItem}>
            <div className={styles.statNumber}>전국</div>
            <div className={styles.statLabel}>의뢰 지역</div>
          </div>
        </div>
        <a href="/requestapplication" className={styles.requestBtn}>
          의뢰 신청
          <span className="material-symbols-outlined" style={{ fontSize: 18 }}>
            chevron_right
          </span>
        </a>
      </div>

      {/* 마키 카드 */}
      <div className={styles.marqueeWrap}>
        <div className={styles.marqueeTrack}>
          {marqueeItems.map((item, index) => (
            <div
              key={index}
              className={styles.requestCard}
              onClick={() => {
                const realIndex = index % estimateData.length;
                alert.showContentModal(
                  <EstimateModal
                    onClickToggleModal={onClickToggleModal}
                    estimateService={estimateData[realIndex]}
                  />,
                  { width: "900px;" }
                );
              }}
            >
              <div className={styles.cardRegion}>{item.address}</div>
              <div className={styles.cardType}>{item.service_type}</div>
              <div className={styles.cardPrice}>
                <span>{util.addComma(item.amount)}</span>원
              </div>
              <div className={styles.cardDate}>{item.end_date}</div>
              <div className={styles.cardFooter}>
                <div className={`${styles.cardStatus} ${statusClassMapper[item.status] || ''}`}>
                  {statusMapper[item.status]}
                </div>
                <div className={styles.cardCompany}>
                  <img src="/images/ddusul/icon/level1.png" alt="" />
                  <span>{item.company_name}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
